/* global jQuery */

const registry = {};

/**
 * This helper is supposed to detect double clicks on jQuery elements. It can be used to prevent
 * double clicks caused by screen readers.
 * @param {Object} e A jQuery event
 * @param {number} [timeout=800] An optional timeout
 * @returns {boolean}
 */
const isDoubleClick = (e, timeout = 800) => {
  if (e instanceof jQuery.Event === false || e.type !== 'click') {
    return false;
  }

  if (!registry[e.target]) {
    registry[e.target] = {
      lastClick: 0,
      timeout,
    };
  }

  const entry = registry[e.target];

  let abort = false;

  if ((e.timeStamp - entry.lastClick) < timeout) {
    abort = true;
  }

  entry.lastClick = e.timeStamp;

  if (abort) {
    return true;
  }

  return false;
};

export default isDoubleClick;



// WEBPACK FOOTER //
// ./Library/1.0/common/is-double-click.js